/**
 * 与旧版官网 `official_website/index.jsx` 中「我的私域」一致的进私域逻辑（toHome / getUrl / toTeamUrl）。
 */
import { message } from "antd";
import apolloClient from "../../../apollo_client";
import { HAVE_ME_TEAM, parseIdByTeamUrl } from "@api/team";
import { verifyUserToken, userTempToken, verifyUserTempToken } from "@api/login";
import { getCookie, getLastOrigin, setCookie } from "@util/utils";
import { defaultHostname } from "@util/enum";

function replaceUrl(url) {
  const start = url.indexOf("//") + 2;
  const end = url.indexOf(".") + 1;
  const str = url.substring(start, end);
  const newUrl = url.replace(str, "");
  if (newUrl === "https://at.bujue.art") {
    return "https://www.bujue.art";
  }
  return newUrl;
}

function getClientIdFromUrl(url) {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url, location.origin);
    const hashQueryIndex = parsedUrl.hash.indexOf("?");
    const hashParams = hashQueryIndex >= 0
      ? new URLSearchParams(parsedUrl.hash.slice(hashQueryIndex + 1))
      : null;

    return hashParams?.get("clientId") || parsedUrl.searchParams.get("clientId") || "";
  } catch (_) {
    return "";
  }
}

function goToLogin() {
  if (defaultHostname.includes(location?.hostname)) {
    window.location.href = "/login.html";
    return;
  }

  window.location.href = replaceUrl(location.origin) + "/login.html";
}

function goToSubscribe(clientId) {
  window.location.href = `${location.origin}/team_cloud.html/#/cloud?&clientId=${encodeURIComponent(clientId)}&selectTab=9`;
}

function getUrl(isSubscribe = false) {
  if (!defaultHostname.includes(location?.hostname)) {
    const newUrl = replaceUrl(location.origin);
    window.location.href = newUrl;
    return;
  }

  apolloClient
    .query({ query: HAVE_ME_TEAM, fetchPolicy: "network-only" })
    .then((res) => {
      const myTeamData = res?.data?.have_me_team;
      let newTeam = null;
      const lastUrl = localStorage.getItem("lastUrl");
      const lastClientId = getClientIdFromUrl(lastUrl);
      let lastIsMyTeam = false;
      let lastClientIsMyTeam = false;

      if (myTeamData?.myCreated?.length) {
        myTeamData.myCreated.forEach((item) => {
          if (lastUrl?.indexOf(item.id) !== -1) {
            lastIsMyTeam = true;
          }
          if (lastClientId === item.id) lastClientIsMyTeam = true;
          if (!newTeam) {
            newTeam = { ...item };
          } else if (item.tmCreate > newTeam?.tmCreate) {
            newTeam = { ...item };
          }
        });
      }
      if (myTeamData?.myJoin?.length) {
        myTeamData.myJoin.forEach((item) => {
          if (lastUrl?.indexOf(item.id) !== -1) {
            lastIsMyTeam = true;
          }
          if (lastClientId === item.id) lastClientIsMyTeam = true;
          if (!newTeam) {
            newTeam = { ...item };
          } else if (item.tmCreate > newTeam?.tmCreate) {
            newTeam = { ...item };
          }
        });
      }
      if (!newTeam) {
        window.location.href = "/team_create.html";
        return;
      }
      if (isSubscribe) {
        goToSubscribe(lastClientIsMyTeam ? lastClientId : newTeam.id);
        return;
      }
      if (lastUrl && lastIsMyTeam) {
        let href = lastUrl;
        if (href?.indexOf("token") !== -1) {
          href = href.replace("token", "test");
        }
        window.location.href = getLastOrigin(href);
        return;
      }
      if (newTeam) {
        window.location.href = `/team_home.html?clientId=${newTeam.id}&clientType=2`;
        return;
      }
      window.location.href = "/user_home.html";
    });
}

function toTeamUrl(needToken) {
  if (defaultHostname.includes(location?.hostname)) {
    window.location.href = "/login.html";
    return;
  }
  parseIdByTeamUrl(location?.hostname)
    .then((res) => {
      if (res.success && res.result) {
        if (needToken) {
          userTempToken()
            .then((r) => {
              if (r.success) {
                setCookie("mtoken", r.result?.tempToken);
              }
            })
            .finally(() => {
              window.location.href = `${location.origin}/team_home.html?clientType=2&clientId=${res.result}`;
            });
        } else {
          window.location.href = `${location.origin}/team_home.html?clientType=2&clientId=${res.result}`;
        }
      } else {
        const newUrl = replaceUrl(location.origin);
        window.location.href = newUrl + "/login.html";
      }
    })
    .catch(() => {
      const newUrl = replaceUrl(location.origin);
      window.location.href = newUrl + "/login.html";
    });
}

/**
 * @param {{ platform: string, isWx?: boolean, isDd?: boolean, token?: string, isSubscribe?: boolean }} opts
 */
export function navigateToPrivateDomain({
  platform,
  isWx,
  isDd,
  token = getCookie("mtoken"),
  isSubscribe = false
}) {
  if (platform === "phone") {
    if (isWx || isDd) {
      window.open("https://bujue.art/down_app.html");
    } else {
      const appUrl = "bujue://";
      window.location.href = appUrl;
      const UA = navigator.userAgent.toUpperCase();
      message.loading({
        content: "正在打开APP,请稍等",
        key: "load",
        duration: 0,
      });
      if (UA.indexOf("IOS") !== -1 || UA.indexOf("IPHONE") !== -1) {
        setTimeout(() => {
          message.destroy("load");
          if (document.hidden) {
            // 成功打开 APP
          } else {
            window.location.href = "/down_app.html?iSDown=1";
          }
        });
      } else {
        setTimeout(
          () => {
            message.destroy("load");
            if (document.hidden) {
              // 成功打开 APP
            } else {
              window.location.href = "/down_app.html?iSDown=1";
            }
          },
          3000
        );
      }
    }
  } else if (token) {
    verifyUserTempToken().then((res) => {
      if (res.success) {
        if (res.result?.isValid === -1) {
          verifyUserToken().then((result) => {
            if (result.success) {
              if (!result.result?.isValid) {
                setCookie("mtoken", "", 7);
                window.location.href = "/login.html";
                return;
              }
              if (result.result?.isValid === 1) {
                getUrl(isSubscribe);
              }
            }
          });
          return;
        }
        if (isSubscribe) {
          goToLogin();
          return;
        }
        if (res.result?.isValid === 1) {
          toTeamUrl();
          return;
        }
        if (res.result?.isValid === 0) {
          toTeamUrl(true);
        }
      } else {
        setCookie("mtoken", "", 7);
        window.location.href = "/login.html";
      }
    });
  } else {
    if (isSubscribe) {
      goToLogin();
      return;
    }
    toTeamUrl(true);
  }
}
